import { EntityAudit } from "@modernary/mui/components/audit";
import { EntityDocuments } from "@modernary/mui/components/document";
import { RouterView, type RouterOptions } from "vue-router";
import { complaintEnforcementActionRouteName } from "../enforcementAction/enforcementAction";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  complaintEnforcementActions: "ComplaintEnforcementAction.ComplaintEnforcementActions",
  list: "ComplaintEnforcementAction.ComplaintEnforcementActionsList",
  new: "ComplaintEnforcementAction.ComplaintEnforcementActionNew",
  base: "ComplaintEnforcementAction.ComplaintEnforcementActionBase",
  view: "ComplaintEnforcementAction.ComplaintEnforcementActionView",
  edit: "ComplaintEnforcementAction.ComplaintEnforcementActionEdit",
  documents: "ComplaintEnforcementAction.ComplaintEnforcementActionDocuments",
  documentsEdit: "ComplaintEnforcementAction.ComplaintEnforcementActionDocumentsEdit",
  documentsNew: "ComplaintEnforcementAction.ComplaintEnforcementActionDocumentsNew",
  audit: "ComplaintEnforcementAction.ComplaintEnforcementActionAudit",
};

export { names as complaintEnforcementActionRouteNames };

const complaintEnforcementActionRoutes: RouterOptions["routes"] = [
  {
    path: "/complaintEnforcementAction",
    name: names.complaintEnforcementActions,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: {
          title: "Complaint Enforcement Actions",
          lookupGroups: ["ProgramType", "DeliveryMethod", "InspectionType"],
        },
        component: () => import("@/views/complaintEnforcementActions/ComplaintEnforcementActionsList.vue"),
      },
      {
        path: "new/:inspectionId(\\d+)?",
        component: () => import("@/views/complaintEnforcementActions/ComplaintEnforcementActionBase.vue"),
        redirect: { name: names.new },
        props: true,
        children: [
          {
            path: "",
            name: names.new,
            meta: { title: "New Enforcement Action", isNew: true },
            component: () => import("@/views/enforcementAction/EnforcementActionEdit.vue"),
            props: { entityRouteName: complaintEnforcementActionRouteName },
          },
        ],
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/complaintEnforcementActions/ComplaintEnforcementActionBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Complaint Enforcement Action View" },
            component: () => import("@/views/enforcementAction/EnforcementActionView.vue"),
            props: { entityRouteName: complaintEnforcementActionRouteName },
          },
          {
            path: "edit",
            name: names.edit,
            meta: { title: "Complaint Enforcement Action Edit", isForm: true },
            component: () => import("@/views/enforcementAction/EnforcementActionEdit.vue"),
            props: { entityRouteName: complaintEnforcementActionRouteName },
          },

          {
            path: "documents",
            name: names.documents,
            meta: { title: "Complaint Enforcement Action Documents" },
            component: {
              render: () => (
                <EntityDocuments
                  idField="enforcementActionId"
                  routeNamePrefix="ComplaintEnforcementAction.ComplaintEnforcementActionDocuments"
                />
              ),
            },
            props: { entityRouteName: complaintEnforcementActionRouteName },
          },
          {
            path: "documents/:documentId(\\d+)",
            name: names.documentsEdit,
            meta: { title: "Edit Complaint Enforcement Action Document", isForm: true },
            component: () => import("@/views/enforcementAction/EnforcementActionDocument.vue"),
            props: { entityRouteName: complaintEnforcementActionRouteName },
          },
          {
            path: "documents/new",
            name: names.documentsNew,
            meta: { title: "Create Complaint Enforcement Action Documents", isForm: true },
            component: () => import("@/views/enforcementAction/EnforcementActionDocuments.vue"),
            props: { entityRouteName: complaintEnforcementActionRouteName },
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Complaint Enforcement Action Audit Activity" },
            component: {
              render: () => <EntityAudit entityType="EnforcementAction" />,
            },
          },
        ],
      },
    ],
  },
];
export default complaintEnforcementActionRoutes;
